var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch"},[_c('content-view',[_c('div',{staticClass:"wrap-container-in"},[_c('a-table',{staticStyle:{"margin-top":"20px"},attrs:{"bordered":"","dataSource":_vm.dataSource,"columns":_vm.columns,"pagination":_vm.pagination,"rowKey":record => record.id},on:{"change":_vm.changePage}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }